import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../component/sharedComponents/header";
import FooterUser from "../component/sharedComponents/footer";
import SidebarUser from "../component/accountUser/sideBarUsers";
import axios from "axios";
import BASE_URL from "../redux/constent";
import { useLanguageNavigate } from "../hooks/useLanguageNavigation";

const AccountUser = () => {
  // const navigate = useNavigate();
  const navigateWithLang = useLanguageNavigate();

  const [tokenFound, setTokenFound] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigateWithLang("/login", { state: true });
      return;
    }

    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/myData`, {
          headers: { token: ` ${token}` },
        });
        const role = response.data?.data?.user?.role;
        setUserRole(role);
        setTokenFound(true);

        if (role === "admin") {
          navigateWithLang("/Dashboard");
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
        navigateWithLang("/login", { state: true });
      }
    };

    fetchUserData();
  }, [navigateWithLang]);

  if (!tokenFound) {
    return null;
  }

  return (
    <>
      <Header />
      <div className="mt-[55px] md:mt-[56px] lg:mt-[75px]">
        <SidebarUser userRole={userRole} />
      </div>
      <FooterUser />
    </>
  );
};

export default AccountUser;
